import { Environments } from "src/environmentInfo/Constants";
import { COGNITO_CONFIGS, LOCALHOST_COGNITO_CONFIG } from "./constants";
export const authConfig = {
  local: LOCALHOST_COGNITO_CONFIG,
  alpha: COGNITO_CONFIGS[Environments.ALPHA],
  beta: COGNITO_CONFIGS[Environments.BETA],
  gamma: COGNITO_CONFIGS[Environments.GAMMA],
  prod: COGNITO_CONFIGS[Environments.PROD],
};
